import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userData: [],
  loading: false,
  error: undefined,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    clearError(state) {
      state.error = undefined;
    },
    actionStart(state) {
      state.loading = true;
      state.error = undefined;
    },
    setCurrentUser(state, action) {
      console.log("setCurrentUser reducer");
      state.userData = action.payload;
      state.loading = false;
      state.error = undefined;
      state.checking = false;
      state.hasChecked = true; // ← BITNO
    },

    clearUser(state) {
      console.log("clearUser reducer");
      state.userData = [];
      state.loading = false;
      state.error = undefined;
      state.checking = false; // ← BITNO
      state.hasChecked = true; // ← BITNO
    },
  },
});

export const userActions = userSlice.actions;

export default userSlice.reducer;
